/* Open battles don't have preset teams, or loadouts, so we need to merge in arena positions. */

export function applyArenaPositionsForOpenBattle(combatants, teams) {

  let nextTeamOnePosition = 1;
  let nextTeamTwoPosition = 1;

  let payload = {};

  Object.keys(combatants).forEach(key => {
    const model = combatants[key];

    if (teams.one.combatantIds.includes(key)) {
      payload[key] = {
        ...model,
        arenaPosition: nextTeamOnePosition
      };
      nextTeamOnePosition++
    }
    if (teams.two.combatantIds.includes(key)) {
      payload[key] = {
        ...model,
        arenaPosition: nextTeamTwoPosition
      };
      nextTeamTwoPosition++
    }

  });

  return {...payload}
}


// WEBPACK FOOTER //
// ./src/battle/connection/applyArenaPositionsForOpenBattle.js